import { api } from "@/api/axios.ts";
import { ApiOperationResult } from "@/types/common.types.ts";
import { ApiFilterBase, ApiPagedData } from "@skailer-com/uikit/core";
import {
  ApiGoal,
  ApiGoalCheckIn,
  ApiGoalCheckInPayload,
  ApiGoalKeyResultFull,
  ApiGoalKeyResultPayload,
  ApiGoalPayload,
  ApiGoalsCount,
  ApiGoalSearchFilter,
} from "@/types/goals.types.ts";

export const goalsApi = {
  search(filter: ApiGoalSearchFilter) {
    return api.post<ApiPagedData<ApiGoal>>(`/api/v1/goals/search`, filter);
  },
  getGoal(id: number) {
    return api.get<ApiGoal>(`/api/v1/goals/${id}`);
  },
  getGoalsStrategic() {
    return api.get<ApiGoal[]>(`/api/v1/goals/strategic`);
  },
  searchStrategic(filter: ApiGoalSearchFilter) {
    return api.post<ApiGoal[]>(`/api/v1/goals/strategic`, filter);
  },
  getGoalsCount() {
    return api.get<ApiGoalsCount>("/api/v1/goals/counts");
  },
  createGoal(payload: ApiGoalPayload) {
    return api.post<ApiGoal>(`/api/v1/goals`, payload);
  },
  updateGoal(id: number, payload: ApiGoalPayload) {
    return api.put<ApiGoal>(`/api/v1/goals/${id}`, payload);
  },
  deleteGoal(id: number, behavior: "move" | "delete" = "move") {
    return api.delete<ApiOperationResult>(`/api/v1/goals/${id}?behavior=${behavior}`);
  },
  createKeyResult(goalId: number, payload: ApiGoalKeyResultPayload) {
    return api.post<ApiGoalKeyResultFull>(`/api/v1/goals/${goalId}/key-results`, payload);
  },
  updateKeyResult(goalId: number, keyResultId: number, payload: ApiGoalKeyResultPayload) {
    return api.put<ApiGoalKeyResultFull>(
      `/api/v1/goals/${goalId}/key-results/${keyResultId}`,
      payload
    );
  },
  deleteKeyResult(goalId: number, keyResultId: number) {
    return api.delete<ApiOperationResult>(`/api/v1/goals/${goalId}/key-results/${keyResultId}`);
  },
  createCheckIn(goalId: number, payload: ApiGoalCheckInPayload) {
    return api.post<ApiGoalCheckIn>(`/api/v1/goals/${goalId}/sessions`, payload);
  },
  updateCheckIn(goalId: number, checkInId: number, payload: ApiGoalCheckInPayload) {
    return api.put<ApiGoalCheckIn>(`/api/v1/goals/${goalId}/sessions/${checkInId}`, payload);
  },
  searchCheckIns(goalId: number, payload: ApiFilterBase) {
    return api.post<ApiPagedData<ApiGoalCheckIn>>(
      `/api/v1/goals/${goalId}/sessions/search`,
      payload
    );
  },
  deleteCheckIn(goalId: number, checkInId: number) {
    return api.delete<ApiOperationResult>(`/api/v1/goals/${goalId}/sessions/${checkInId}`);
  },
};
